import { EyeOutlined } from "@ant-design/icons";
import { ServicePartnerTag } from "@rumble-it/common-lib/types/models/ServicePartnerTag.interface";
import { Button } from "@rumbledirect/ui";
import { TableColumnsType } from "antd";
import { Link } from "react-router-dom";

export const servicePartnerTagColumns: TableColumnsType<ServicePartnerTag> = [
  {
    title: "Naam",
    dataIndex: "name",
    key: "name",
    render: (_: any, record) => (
      <a href={`/service-partners/tags/${record.id}`}>{record.name}</a>
    ),
  },
  {
    title: "Acties",
    key: "actions",
    render: (_: any, record) => (
      <Link to={`/service-partners/tags/${record.id}`}>
        <Button icon={<EyeOutlined />} variant="light" />
      </Link>
    ),
  },
];
